import { Controller } from "@hotwired/stimulus"
import * as bootstrap from 'bootstrap';

export default class extends Controller {
  connect() {
    var notificationOffcanvas = document.getElementById('notificationOffcanvas');
    const bsNotificationOffcanvas = new bootstrap.Offcanvas(notificationOffcanvas);
    bsNotificationOffcanvas.show();
    setTimeout(() => { bsNotificationOffcanvas.hide(); }, 10000);
  }
}
